export default function ({ app, redirect }) {  
  if (app.$cookies.get("auth-token")) {
    return redirect(app.localePath("/account/billing-plan"));
  }
}
